import { FetchDataState } from '@/types/fetchDataState';
import { Glyph } from '@/types/models';

// eslint-disable-next-line no-magic-numbers
export const MAX_FILE_UPLOAD_SIZE = 1024 * 1024;
export type GlyphsState = FetchDataState<Glyph[], []>;
